import { FileDocumentMinusIcon } from './FileDocumentMinusIcon';

/**
 * author: Simran
 * id A7695AE5-5CF1-42B3-BBAE-516D143CF87C
 * name file-document-minus
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-document-minus.svg
 * tags
 * - Files / Folders 
 */
export const FileTextMinusIcon = FileDocumentMinusIcon;
export default FileTextMinusIcon